import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AddressLookupService } from 'src/rdsap/services/configuration/address-lookup.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/rdsap/shared/shared.module';

interface CountryCode {
  code: string;
  name: string;
}

interface Address {
  tempId: string;
  addressLine: string;
  country: string;
}

interface AddressDetails {
  address1?: string;
  address2?: string;
  address3?: string;
  address4?: string;
  town?: string;
  uprn?: string;
}

@Component({
  selector: 'app-create-report',
  templateUrl: './create-report.component.html',
  styleUrls: ['./create-report.component.scss'],
  standalone: true,
  imports: [FormsModule, CommonModule, SharedModule]
})

export class CreateReportComponent implements OnInit, OnDestroy {
  private addressSubscription: Subscription;
  private addressDetailsSubscription: Subscription;
  reportName: string;
  countryCode: string;
  postcode: string;
  selectedAddress: Address;
  addresses: Address[] = [];
  addressDetails: AddressDetails = {};
  isDisabled: boolean = true;
  isManual: boolean = false;
  assessmentDate: string = '';

  countryCodes: CountryCode[] = [
    { code: 'EAW', name: 'England and Wales' },
    { code: 'NIR', name: 'Northern Ireland' },
    { code: 'SCT', name: 'Scotland' }
  ];

  constructor(private route: ActivatedRoute, private addressLookupService: AddressLookupService) {}
  
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.reportName = params['reportName'];
    });
  }

  ngOnDestroy(): void {
    if (this.addressSubscription) {
      this.addressSubscription.unsubscribe();
    }
    if (this.addressDetailsSubscription) {
      this.addressDetailsSubscription.unsubscribe();
    }
  }

  lookupAddress() {
    if(this.countryCode && this.postcode) {
      this.selectedAddress = null;
      this.addressSubscription = this.addressLookupService.getAddressList(this.countryCode, this.postcode).subscribe(data => {
        this.addresses = data.map(item => ({
          ...item,
          addressLine: item.addressLine.replace(/;/g, ' ')
        }));
        this.addresses = this.sortAddressesByNumber(this.addresses);
      });
    }
  }

  onSelectAddress(address: Address) {
    this.selectedAddress = address;
    this.addressDetailsSubscription = this.addressLookupService.getFullAddress(this.countryCode, address.tempId).subscribe(details => {
      if (details.uprn) {
        details.uprn = details.uprn.replace('UPRN-', '');
      }
      this.addressDetails = details;
    });
  }

  private sortAddressesByNumber(addresses: Address[]): Address[] {
    return addresses.sort((a, b) => {
      const aNumber = parseInt(a.addressLine.match(/\d+/)?.[0] || '0', 10);
      const bNumber = parseInt(b.addressLine.match(/\d+/)?.[0] || '0', 10);
      return aNumber - bNumber;
    });
  }

  enterManuallyAddress(event) {
    if(event) {
      this.isDisabled = false;
      this.isManual = true;
      this.postcode = null;
      this.addresses = [];
      this.addressDetails = {};
    }
  }
}
